<script setup lang="ts">
import { inject, ref } from 'vue';
import { useField } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { z } from 'zod';

import VInput from '@shared/form/VInput/VInput.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import { isDisabledInjectionKey, isReadonlyInjectionKey } from '../keys';

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });

const voorletters = useField(
  'voorletters',
  toTypedSchema(z.string({ required_error: 'Voorletters zijn verplicht' }).min(1).max(10)),
);
const tussenvoegsels = useField(
  'tussenvoegsels',
  toTypedSchema(z.nullable(z.string().max(10).optional())),
);
const naam = useField(
  'achternaam',
  toTypedSchema(z.string({ required_error: 'Achternaam is verplicht' }).min(1).max(32)),
);
</script>

<template>
  <FieldRowV2
    :errors="[...voorletters.errors.value, ...tussenvoegsels.errors.value, ...naam.errors.value]"
    label="Naam"
    :required="!hasReadonlyParent"
    v-bind="$attrs"
  >
    <div class="flex flex-grow flex-wrap gap-6" v-if="!hasReadonlyParent">
      <VInput
        v-model="voorletters.value.value"
        class="flex-grow basis-24"
        :has-error="!!voorletters.errors.value.length"
        id="relatiegegevens-voorletters"
        :is-disabled="hasDisabledParent"
        :is-readonly="hasReadonlyParent"
        :max-length="10"
        placeholder="Voorletters"
      />

      <VInput
        v-model="tussenvoegsels.value.value"
        class="flex-grow basis-32"
        :has-error="!!tussenvoegsels.errors.value.length"
        id="relatiegegevens-tussenvoegsel"
        :is-disabled="hasDisabledParent"
        :is-readonly="hasReadonlyParent"
        :max-length="10"
        placeholder="Tussenvoegsel"
      />

      <VInput
        v-model="naam.value.value"
        class="flex-grow basis-56"
        :has-error="!!naam.errors.value.length"
        id="relatiegegevens-achternaam"
        :is-disabled="hasDisabledParent"
        :is-readonly="hasReadonlyParent"
        is-required
        :max-length="30"
        placeholder="Achternaam"
      />
    </div>
    <div v-else>
      {{
        `${voorletters.value.value || ''} ${tussenvoegsels.value.value ? `${tussenvoegsels.value.value} ` : ''}${naam.value.value || ''}`.trim() ||
        '-'
      }}
    </div>
  </FieldRowV2>
</template>
